import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="size-fields"
// Maneja campos dinámicos para las tallas de una corrida
export default class extends Controller {
  static targets = ["container", "template", "input"]

  connect() {
    this.index = this.inputTargets.length
  }

  add(event) {
    event.preventDefault()
    
    const newField = this.createField("")
    this.containerTarget.insertAdjacentHTML("beforeend", newField)
    this.index++
    
    // Focus en el nuevo campo
    const inputs = this.containerTarget.querySelectorAll("input[type='text']")
    const lastInput = inputs[inputs.length - 1]
    if (lastInput) {
      lastInput.focus()
    }
  }

  remove(event) {
    event.preventDefault()
    
    const field = event.target.closest(".size-field-item")
    if (field) {
      field.remove()
      this.reindex()
    }
  }

  createField(value) {
    const html = `
      <div class="size-field-item" data-size-fields-target="input">
        <input type="text" 
               name="size_run[sizes][]" 
               value="${this.escapeHtml(value)}" 
               class="form-control" 
               placeholder="Ej: 22, 22.5, 23..."
               required>
        <button type="button" 
                class="btn-icon btn-delete" 
                data-action="click->size-fields#remove"
                title="Eliminar talla">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 6 6 18M6 6l12 12"/>
          </svg>
        </button>
      </div>
    `
    return html
  }

  reindex() {
    // Reindexar no es necesario porque usamos sizes[] como array
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
